<script lang="ts" setup>
const props = defineProps<{
  customClass?: string
}>()
</script>

<template>
  <span
    class="d-flex align-center mx-1 justify-center px-1"
    :class="props.customClass"
    style="width: fit-content"
  >
    <slot />
  </span>
</template>
